import { ReactNode } from 'react'
import { ConfigProvider } from 'antd'
import locale from 'antd/locale/ru_RU'

export const AntDesignConfigProvider = ({ children }: { children: ReactNode }) => {
  const theme = {
    token: {
      fontFamily: `'Montserrat', sans-serif`,
      fontSize: 13,
      controlHeight: 48,
      borderRadius: 16
    },
    components: {
      Button: {
        colorPrimary: '#e7e9f8',
        colorPrimaryHover: '#e7e9f8',
        colorTextLightSolid: '#1B1464',
        defaultActiveColor: '#4096ff',
        defaultActiveBorderColor: '#4096ff',
        colorPrimaryTextActive: '#FFFFFF',
        defaultActiveBg: '#4096ff',
        // colorBgContainer: '#ffffff',
        borderRadius: 16,
        fontSize: 14,
        fontWeight: 600,
        fontFamily: 'Montserrat',
        dangerColor: '#FFFFFF',
        dangerColorHover: '#ED1E79'
      },
      DatePicker: {
        borderRadius: 16,
        fontSize: 13,
        fontFamily: 'Montserrat',
        color: '#000000'
      },
      RangePicker: {
        borderRadius: 16,
        fontSize: 13,
        fontFamily: 'Montserrat',
        color: '#000000'
      },
      Collapse: {
        borderRadiusLG: 16,
        colorBgContainer: '#EEF6F7 ',
        colorBorder: 'rgba(27, 20, 100, 0.35)',
        collapseHeaderPadding: 0,
        paddingSM: 8,
        padding: 4,
        color: 'rgb(27, 20, 100)',
        contentBg: '#F5F5F5',
        headerBg: '#F5F5F5',
        headerPadding: 0,
        contentPadding: 0,
        colorTextHeading: 'rgba(27, 20, 100)',
        fontSizeIcon: 12
      },
      Select: {
        borderRadius: 16
      },
      Popover: {
        zIndexPopup: 3
      },
      Tooltip: {
        colorBgSpotlight: 'rgb(237,30,121)',
        borderRadiusXS: 6,
        borderRadius: 6,
        fontFamily: 'Montserrat'
      }
    },

    hashed: false
  }

  return (
    <ConfigProvider theme={theme} locale={locale}>
      {children}
    </ConfigProvider>
  )
}
